import { Button, Radio, Text } from "@/atoms"
import cn from "classnames"

import styles from "./RadioFilter.module.scss"

export interface RadioFilterItemOptions {
  label: string
  value: string
  displayLabel: boolean
}

export interface RadioFilterItemProps {
  name: string
  title: string
  Icon: React.FC
  value: string | boolean | number
  options: RadioFilterItemOptions[]
  onChange: (value: Record<string, unknown>) => void
}

export const RadioFilterItem = ({
  name,
  title,
  Icon,
  value,
  options,
  onChange
}: RadioFilterItemProps) => {
  const currentOptions = options.map(({ label, displayLabel, ...attr }) => ({
    label: displayLabel || label,
    ...attr
  }))

  return (
    <div className={styles.radioItemContainer}>
      <Text className={styles.radioItemText}>
        <Icon />
        {title}
      </Text>
      <div className={styles.radioItemButtonContainer}>
        <Button
          className={cn(styles.radioItemClearButton, !value && styles.hide)}
          type="text"
          onClick={() => onChange({ [name]: null })}
        >
          Clear
        </Button>
        <Radio.Group
          className={styles.radioItemGroup}
          name={name}
          size="small"
          options={currentOptions}
          onChange={({ target }) => {
            onChange({ [name]: target.value })
          }}
          optionType="button"
          buttonStyle="solid"
          value={value}
        />
      </div>
    </div>
  )
}
